import React from 'react'

// GIPHY search is temporarily removed - only upload from computer is supported
function EditorInsertGIFModal({ handleSelectFile, closeInsertImageModal }) {
  return (
    <div className='editor-insertImageModal editor-insertImageModal--gif'>
      <div className='editor-insertImageModal-gifHeader'>
        <div className='editor-insertImageModal-gifHeader-title'>
          Animated GIF
        </div>
        <button onClick={closeInsertImageModal} className='editor-insertImageModal-gifHeader-cancelBtn'>
          Cancel
        </button>
      </div>
      <div className='editor-insertImageModal-gifBody'>
        <input
          id='file'
          type='file'
          value=''
          name='uploadGIF'
          accept='.gif, .webp'
          className='editor-insertImageModal-footer-hiddenUploadInput'
          onChange={(e) => { handleSelectFile(e) }}
        />
        <label htmlFor='file' className='editor-insertImageModal-footer-uploadBtn'>
          <div className='editor-insertImageModal-footer-uploadBtn-primary'>
            Upload Animated GIF from Computer...
          </div>
          <div className='editor-insertImageModal-footer-uploadBtn-secondary'>
            Maximum file size: 20MB
          </div>
        </label>
      </div>
    </div>
  )
}

export default EditorInsertGIFModal
